<template>
  <fieldset class="tag-input">
    <label>{{ label }}</label>

    <div v-on:click="openDrawer" :class="{
      'tag-input-field': true,
      'active': isOpen
      }">
      <div 
        class="tag"
        v-for="tag in selectedTags"
        v-bind:key="'selectedTag_' + tag">
          {{ tag }}
          <span class="remove-tag" v-on:click="removeTag(tag)">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="10" height="10" viewBox="0 0 512 512">
                <path d="M256.010 204.645l100.118-100.146 51.344 51.33-100.118 100.146-51.344-51.329z"/>
                <path d="M155.827 407.483l-51.344-51.358 100.161-100.132 51.344 51.358-100.161 100.132z"/>
                <path d="M407.498 356.112l-51.373 51.358-100.118-100.146 51.373-51.358 100.118 100.146z"/>
                <path d="M104.502 155.857l51.337-51.351 100.153 100.125-51.337 51.351-100.153-100.125z"/>
                <path d="M255.983 307.36l-51.351-51.365 51.365-51.351 51.351 51.365-51.365 51.351z"/>
            </svg>
          </span>
      </div>
    </div>

    <div v-show="isOpen" class="tag-selection-box">
      <!-- <div>
        <span v-if="type === TagType.select">Please select one</span>
        <span v-if="type === TagType.multiselect">Select all that apply</span>
      </div> -->

      <div 
        :class="{
          'tag': true,
          'tag--selected': tagIsAdded(option)
          }"
        v-for="option in options"
        v-bind:key="'option_' + option"
        v-on:click="addTag(option)">
          {{ option }}
          <div class="tag-status"></div>
      </div>
    </div>
  </fieldset>
</template>

<script>
  import { TagType } from '../services/BookingDetailsProvider'

  export default {
    name: 'tagInput',
    props: [
      'label',
      'value',
      'options',
      'type'
    ],
    data () {
      return {
        isOpen: false,
        selectedTags: [],
        TagType
      }
    },
    methods: {
      openDrawer () {
        this.isOpen = true
      },
      closeDrawer () {
        this.isOpen = false
      },
      clearTags () {
        this.selectedTags = []
      },
      tagIsAdded (tag) {
        return this.selectedTags.includes(tag)
      },
      canAddTag (tag) {
        if (!this.isMultiSelect()) {
          return this.selectedTags.length < 1 && !this.tagIsAdded(tag)
        }

        return !this.tagIsAdded(tag)
      },
      emitChange () {
        if (this.isMultiSelect()) {
          this.$emit('input', this.selectedTags)
        } else {
          this.$emit('input', this.selectedTags[0])
        }
      },
      addTag (tag) {
        if (!this.isMultiSelect() && !this.tagIsAdded(tag)) {
          this.clearTags()
          this.selectedTags.push(tag)
          this.closeDrawer()
          this.emitChange()
          return
        }

        if (!this.canAddTag(tag)) {
          this.removeTag(tag)
          this.emitChange()
          return
        }

        this.selectedTags.push(tag)

        if (!this.isMultiSelect()) {
          this.isOpen = false
        }

        this.emitChange()
      },
      removeTag (tag) {
        if (!this.tagIsAdded(tag)) return

        const location = this.selectedTags.indexOf(tag)

        this.selectedTags.splice(location, 1)
        this.emitChange()
      },
      outsideClickEventListener (event) {
        const tagInputEl = this.$el
        const clickEl = event.target

        if (!tagInputEl.contains(clickEl)) {
          this.isOpen = false
        }
      },
      isMultiSelect () {
        return this.type === TagType.multiselect
      }
    },
    mounted () {
      this.$root.$el.addEventListener('click', this.outsideClickEventListener)
    },
    destroyed () {
      this.$root.$el.removeEventListener('click', this.outsideClickEventListener)
    }
  }
</script>




// WEBPACK FOOTER //
// tagInput.vue?08e0b09e